<template>
  <div>
    <div>
      <ul v-if="skus" style="list-style: none" class="parts-list">
        <li style="text-align: left" v-for="(s, index) in skus" :key="s.id">
          <strong>{{ s.shippingSkuAmount }} x {{ s.shippingSkuName }}</strong> {{ " " }}
          <span v-if="s.shippingSkuCarrier || s.shippingSkuLocation" class="desc">({{ s.shippingSkuCarrier }}, {{ parseShippingSkuLocation(s.shippingSkuLocation, s.id, s) }}) </span>
          <md-button class="md-icon-button md-dense btn-flat md-accent" @click="removeSku(index)">
            <md-icon>delete</md-icon>
          </md-button>
        </li>
      </ul>
    </div>
    <md-button class="md-secondary" @click="showAddSkuModal">{{ $t("orders.orderSkus.addSku") }}</md-button>

    <modal v-if="addSkuModal" @close="hideAddSkuModal" class-name="modal-add-sku modal-lg">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.orderSkus.addSku") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideAddSkuModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <ValidationObserver ref="addSkuForm">
          <ValidationProvider name="addSkuForm.shippingSkuAmount" :rules="newSku.shippingSkuName ? `required|max_value:${newSku.shippingSkuInventory}` : 'required'" v-slot="{ errors }">
            <md-field>
              <label for="shippingSkuAmount">{{ $t("orders.shippingSkuAmount") }}</label>
              <md-input v-model="newSku.shippingSkuAmount" required type="sku"></md-input>
              <div class="md-error" v-if="errors[0]">
                {{ $t(errors[0]) }}
              </div>
            </md-field>
          </ValidationProvider>

          <ValidationProvider name="addSkuForm.shippingSkuCarrier" :rules="'required'" v-slot="{ errors }">
            <md-field class="md-required">
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left">
                <label v-if="!!newSku.shippingSkuCarrier" for="shippingSkuCarrier">{{ $t("orders.shippingSkuCarrier") }}</label>
                <SelectCarrier v-model="newSku.shippingSkuCarrier" :multiple="false" :customClass="'custom-select'" />
              </div>
              <div class="md-error" v-if="errors[0]">
                {{ $t(errors[0]) }}
              </div>
            </md-field>
          </ValidationProvider>

          <ValidationProvider name="addSkuForm.shippingSkuInventoryObj" :rules="'required'" v-slot="{ errors }">
            <div class="wrap-v-select custom-wrap-v-select mt-4 mb-4" style="text-align: left; margin-bottom: 0">
              <v-select
                :filterable="false"
                :options="inventories"
                :placeholder="$t('orders.shippingSkuName') + ' & ' + $t('orders.shippingSkuLocation')"
                @search="onSearchInvetories"
                v-model="shippingSkuInventoryObj"
                class="custom-select"
                required
              >
                <template slot="no-options"> no record... </template>
                <template slot="option" slot-scope="option">
                  <div :class="`d-center ${option.exact ? 'exact' : ''}`" v-html="option.name"></div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center" v-html="option.name"></div>
                </template>
                <template #open-indicator="{}">
                  <i class="md-icon md-icon-font md-icon-image md-theme-default">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 10l5 5 5-5z"></path>
                      <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                  </i>
                </template>
              </v-select>
              <div class="md-error" v-if="errors[0]">
                {{ $t(errors[0]) }}
              </div>
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </template>

      <template slot="footer">
        <md-button class="md-secondary mr-1" @click="hideAddSkuModal">{{ $t("orders.cancel") }}</md-button>
        <md-button class="md-success" @click="addSku">{{ $t("orders.add") }}</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { debounce } from "lodash";
import axiosFactory from "../../services/axios.factory";
import { format } from "date-fns";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SelectCarrier from "../SelectCarrier/SelectCarrier.vue";
import Modal from "../Modal.vue";

export default {
  components: { ValidationObserver, ValidationProvider, SelectCarrier, Modal },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inventories: [],
      selectedInventories: [],
      shippingSkuInventoryObj: null,
      skus: [...this.value],
      addSkuModal: false,
      newSku: {
        shippingSkuAmount: null,
        orderSkuDescription: "",
        shippingSkuLocation: "",
        shippingSkuName: null,
        shippingSkuCarrier: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapState("warehouses", ["storageLocations"]),
  },
  methods: {
    onSelectInventory(selected) {
      console.log(selected, "selected");
      if (!selected || !selected.raw) {
        return;
      }
      const item = { ...selected.raw };
      this.selectedInventories.push(item);
      this.newSku.shippingSkuInventory = item.inventory - item.reserved; // item.inventory;

      this.newSku.shippingSkuName = item.sku;
      this.newSku.shippingSkuLocation = `${item.storageLocationId}:${item.inventory}:${item.id}`;
    },
    onSearchInvetories(search, loading) {
      if (search.length) {
        loading(true);
        this.searchInventory(loading, search, this);
      }
    },
    searchInventory: debounce((loading, search, vm) => {
      axiosFactory()
        .get(`/warehouses/inventories?keywords=${search}&pageIndex=0&pageSize=100&isAvailable=true`)
        .then((res) => {
          const items = res.data.data.map((p) => {
            const item = {
              //
              value: p.id,
              name: `${p.sku} (${p.warehouseCode}-${p.storageLocation} | ${vm.$t("wms.inventory")}: <strong>${p.inventory}</strong> | ${vm.$t("wms.reserved")}: ${p.reserved} | ${format(
                Date.parse(p.date),
                "dd.MM.yyyy"
              )})`,
              label: `${p.sku} (${p.warehouseCode}-${p.storageLocation}:${p.inventory})`,
              raw: { ...p },
              exact: p.sku.toLowerCase() === search?.toLowerCase(),
            };
            return item;
          });
          vm.inventories = items.sort((a, b) => {
            return a.exact > b.exact ? -1 : a.exact < b.exact ? 1 : 0;
          });
          loading(false);
        });
    }, 300),
    async fetchDefaultStorageLocation() {
      if (!this.storageLocations || !this.storageLocations.length) {
        await this.getStorageLocations();
      }
      const defaultLocation = this.storageLocations.find((loc) => loc.id === 544);
      this.newSku.storageLocation = defaultLocation ? { id: defaultLocation.id, fullName: defaultLocation.fullName } : { id: 544, name: "PP-88-88-88" };
      this.newSku.storageLocationId = defaultLocation?.id ?? 544;
    },
    showAddSkuModal() {
      this.fetchDefaultStorageLocation();
      this.addSkuModal = true;
    },
    hideAddSkuModal() {
      this.addSkuModal = false;
      this.resetSkuModal();
    },
    addSku() {
      this.$refs.addSkuForm.validate().then((isValid) => {
        if (!isValid) return;

        const skuItem = {
          shippingSkuAmount: this.newSku.shippingSkuAmount,
          shippingSkuName: this.newSku.shippingSkuName,
          shippingSkuCarrier: this.newSku.shippingSkuCarrier,
          shippingSkuLocation: this.newSku.shippingSkuLocation,
          orderSkuDescription: this.newSku.orderSkuDescription,
        };
        // check if existed
        const exited = this.skus?.findIndex((a) => a.shippingSkuLocation === skuItem.shippingSkuLocation);
        if (exited >= 0) {
          const totalAmt = parseInt(this.skus[exited].shippingSkuAmount) + parseInt(skuItem.shippingSkuAmount);
          this.skus[exited].shippingSkuAmount = totalAmt.toString();
        } else {
          this.skus && this.skus.push(skuItem);
        }

        this.$emit("input", this.skus);
        this.hideAddSkuModal();
      });
    },
    removeSku(index) {
      this.skus.splice(index, 1);
      this.$emit("input", this.skus);
    },
    resetSkuModal() {
      this.newSku = {
        shippingSkuAmount: null,
        shippingSkuName: null,
        shippingSkuCarrier: null,
        shippingSkuLocation: null,
        shippingSkuInventory: null,
        orderSkuDescription: null,
      };
      this.shippingSkuInventoryObj = null;
      this.selectedInventories = [];
      this.inventories = [];
    },
    parseShippingSkuLocation(shippingSkuLocation, orderSkuId, shippingRef) {
      if (!shippingSkuLocation) return "";

      if (shippingSkuLocation.toUpperCase() === "VS") {
        return "PP";
      }

      const locations = [];
      try {
        const parts = shippingSkuLocation.split(";");
        for (let index = 0; index < parts.length; index++) {
          const element = parts[index];
          const inventoryParts = element.split(":");
          let locationId = parseInt(inventoryParts[0]);
          let location = this.storageLocations.find((l) => l.id === locationId);

          let inventory = parseInt(inventoryParts[1]);
          if ((!inventory || isNaN(inventory)) && shippingRef && this.selectedInventories.length) {
            const item = this.selectedInventories.find((i) => i.sku === shippingRef.shippingSkuName);
            inventory = item ? item.inventory : "";
          }

          if (location) {
            locations.push(`${location.fullName}:${inventory}`);
          }
        }
      } catch (e) {
        console.log(e);
      }

      return locations.join(",");
    },
  },
  watch: {
    value(newValue) {
      this.skus = [...newValue];
    },
    shippingSkuInventoryObj(val) {
      this.onSelectInventory(val);
    },
  },
  created() {
    this.fetchDefaultStorageLocation();
  },
};
</script>

<style lang="scss" scoped>
.parts-list {
  list-style: none;
  padding: 0;
  display: inline-block;
}
.parts-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #eee;
  .desc {
    flex: 1 1 auto;
    text-align: left;
  }
}
</style>
